import type { CSSProperties } from "react";

export const authStyles: Record<string, CSSProperties> = {
  wrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--bg-void)",
    fontFamily: "var(--sans)",
  },
  card: {
    width: 360,
    padding: "36px 32px",
    background: "var(--bg-base)",
    border: "1px solid var(--border-subtle)",
    borderRadius: 8,
    color: "var(--text-primary)",
  },
  logoRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 24 },
  logo: {
    width: 24,
    height: 24,
    borderRadius: 5,
    background: "linear-gradient(135deg, var(--accent) 0%, #3060c0 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  brand: {
    fontWeight: 700,
    fontSize: 14,
    color: "var(--text-bright)",
    letterSpacing: "-0.02em",
  },
  heading: {
    fontSize: 18,
    fontWeight: 600,
    color: "var(--text-bright)",
    marginBottom: 20,
  },
  body: {
    fontSize: 13,
    color: "var(--text-primary)",
    lineHeight: 1.5,
    margin: "12px 0",
  },
  form: { display: "flex", flexDirection: "column", gap: 10 },
  input: {
    height: 38,
    padding: "0 12px",
    background: "var(--bg-surface)",
    color: "var(--text-primary)",
    border: "1px solid var(--border-default)",
    borderRadius: "var(--radius-md)",
    fontSize: 13,
    fontFamily: "var(--sans)",
    outline: "none",
  },
  error: {
    fontSize: 12,
    color: "var(--error)",
    padding: "6px 0",
  },
  primaryBtn: {
    height: 38,
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "var(--radius-md)",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "var(--sans)",
    cursor: "pointer",
    marginTop: 4,
  },
  forgotLink: {
    fontSize: 11,
    color: "var(--text-muted)",
    textDecoration: "none",
    textAlign: "right",
    marginTop: -4,
  },
  toggleBtn: {
    background: "none",
    border: "none",
    color: "var(--accent)",
    fontSize: 12,
    fontFamily: "var(--sans)",
    cursor: "pointer",
    textDecoration: "underline",
  },
};
